<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-chalkboard me-2"></i>{{ TR.filter_group }}
        </div>

        <div class="card-body">
            <DADataTable
                ref="filter_table_ref"
                v-if="tableData"
                :tableData="tableData"
                :tableOptions="tableOptions"
            />
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    import DADataTable from "@/components/table/DADataTable";

    export default {
        name: 'FilterP',
        title: "filter",

        // metaInfo: {
        //     title: 'Default App Title',
        //     titleTemplate: '%s | vue-meta Example App',
        //     htmlAttrs: {
        //         lang: 'az-AZ'
        //     },
        //     meta: [
        //         { charset: 'utf-8' },
        //         { vmid: 'description', name: 'description', content: 'An example Vue application with vue-meta.' },
        //         { vmid: 'description', name: 'viewport', content: 'width=device-width, initial-scale=1' },

        //         { property: 'og:title', content: "Epiloge - Build your network in your field of interest" },
        //         { property: 'og:site_name', content: 'Epiloge' },
        //         { property: 'og:type', content: 'website' },
        //         { property: 'og:image', content: '/users/-main.jpg' },

        //         { name: 'robots', content: 'index,follow' },
        //     ]
        // },

        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const filter_table_ref = ref();
            const TR = ref({});

            onMounted(async () => {
                await ajax({
                    url: store.getFilter(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            tableData.value = res;
                            // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                            tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss")));
                        }
                    }
                });
            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: true,
                    // row_total_field: ['rank'],
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    // modal: false,
                                    page: "pages/filter/FilterInfo",
                                    data: {
                                        permission_method: 'add',
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.title,
                                            field_type: "text",
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "rank",
                                            title: TR.value.rank,
                                            value: () => 1,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    onModalClose: (e) => {
                                        G.closeModal(e);
                                    },
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name[1] !== undefined ){
                                                            let filter_data = {
                                                                "rank": e.rank,
                                                                "translate": G.lang_list.map((a) => (
                                                                        {
                                                                            "lang_id": a.value,
                                                                            "name": e.name[a.value] || e.name[1],
                                                                        }
                                                                )),
                                                                "status": e.status ? 1 : 0,
                                                                "group_filters": e.group_filters.map((f) => (
                                                                    {
                                                                        "rank": f.rank,
                                                                        "translate": G.lang_list.map((a) => (
                                                                            {
                                                                                "lang_id": a.value,
                                                                                "name": f.name[a.value] || f.name[1],
                                                                            }
                                                                        )),
                                                                    })
                                                                ),
                                                            };

                                                            await ajax({
                                                                url: store.getFilter(),
                                                                method: 'post',
                                                                content_type: 'application/json',
                                                                data: filter_data,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        // tableData.value.unshift(res);
                                                                        tableData.value.push(res);
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status && res.status == 422 ){
                                                                //         G.alert.error({title: TR.value.warning, msg: G.getErrorMessages(res.data.detail)});
                                                                //     }
                                                                //     else
                                                                //         G.alert.error({msg: TR.value.msg_add_failed});
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getFilterUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: async (data) => {
                                data.permission_method = 'update';

                                await ajax({
                                    url: store.getFilterGroupWithFilters(data.id),
                                    success: (e) => {
                                        let res = e.data || null;
                                        data.group_filters = res.group_filters;
                                    },
                                });

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: data.translate[0].name,
                                    dismiss: false,
                                    page: "pages/filter/FilterInfo",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            value: (l) => l.name,
                                            title: TR.value.name,
                                            field_type: 'text',
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        // {
                                        //     name: "title",
                                        //     value: (e) => e.translate[0].title,
                                        //     title: TR.value.title,
                                        //     field_type: 'text',
                                        // },
                                        // {
                                        //     name: "content",
                                        //     value: (e) => e.translate[0].content,
                                        //     title: TR.value.text,
                                        //     field_type: 'textarea',
                                        // },
                                        {
                                            name: "rank",
                                            value: "rank",
                                            title: TR.value.rank,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if(e && e.name[1] !== undefined){
                                                            let filter_data = {
                                                                "rank": e.rank,
                                                                "translate": G.lang_list.map((a) => (
                                                                        {
                                                                            "lang_id": a.value,
                                                                            "name": e.name[a.value] || e.name[1],
                                                                        }
                                                                )),
                                                                "status": e.status ? 1 : 0,
                                                                "group_filters": e.group_filters.map((f) => (
                                                                    {
                                                                        "id": f.id,
                                                                        "filter_group_id": f.filter_group_id,
                                                                        "rank": f.rank,
                                                                        "translate": G.lang_list.map((a) => (
                                                                            {
                                                                                "lang_id": a.value,
                                                                                "name": f.name[a.value] || f.name[1],
                                                                            }
                                                                        )),
                                                                    })
                                                                ),
                                                            };

                                                            await ajax({
                                                                url: store.getFilterUpdate(data.id),
                                                                method: 'patch',
                                                                content_type: 'application/json',
                                                                data: filter_data,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.forEach(
                                                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        );
                                                                        for (let a in res) {
                                                                            data[a] = res[a];
                                                                        }
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_title});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getFilterActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getFilterActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },

                        // {
                        //     name: "image",
                        //     value: (e) => e.type == 'video' ? '<i class="fas fa-video text-primary"></i>' : ( e.type == 'youtube' ? '<i class="fab fa-youtube text-danger"></i>' :
                        //                         `<img src="${
                        //                                 e.image && typeof e.image !== 'object' && !e.image.match(/youtu/gi)
                        //                                     ? e.image
                        //                                     : "/assets/img/noimg.png"
                        //                             }"
                        //                             alt="${e.image}"
                        //                             class="border img-circle-cover"
                        //                         />`
                        //                     ),
                        //     title: TR.value.image,
                        //     exportable: false,
                        //     sortable: false,
                        //     class: 'text-center',
                        //     filter: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "translate.0.name",
                            value: (e) => e.translate[0].name,
                            title: TR.value.title,
                        },
                        {
                            name: "rank",
                            value: "rank",
                            title: TR.value.rank,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            // function componentToHex(c) {
            //     var hex = c.toString(16);
            //     return hex.length == 1 ? "0" + hex : hex;
            // }
            // function rgbToHex(r, g, b) {
            //     return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
            // }

            return {
                TR,
                filter_table_ref,
                tableData,
                tableOptions,
            };
        },
    };
</script>

